import { ILabReqDTO, LoadType } from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';
import { LabReqEntity } from './lab-req.models';

export const loadLabReq = createAction(
  '[LabReq] Load LabReq',
  props<{ loadType?: LoadType; filters: any }>()
);

export const loadLabReqSuccess = createAction(
  '[LabReq] Load LabReq Success',
  props<{
    labReqs: LabReqEntity[];
    loadType: LoadType;
    limit: number;
    offset: number;
  }>()
);

export const loadLabReqFailure = createAction(
  '[LabReq] Load LabReq Failure',
  props<{ error: any }>()
);

export const saveLabReq = createAction(
  '[LabReq] Save LabReq',
  props<{ labReq: ILabReqDTO }>()
);

export const saveLabReqSuccess = createAction(
  '[LabReq] Save LabReq Success',
  props<{ labReq: LabReqEntity }>()
);

export const saveLabReqFailure = createAction(
  '[LabReq] Save LabReq Failure',
  props<{ error: any }>()
);

export const updateLabReq = createAction(
  '[LabReq] Update LabReq',
  props<{ id: string; labReq: ILabReqDTO }>()
);

export const updateLabReqSuccess = createAction(
  '[LabReq] Update LabReq Success',
  props<{ labReq: LabReqEntity }>()
);

export const updateLabReqFailure = createAction(
  '[LabReq] Update LabReq Failure',
  props<{ error: any }>()
);

export const setActiveLabReqId = createAction(
  '[LabReq] Set Active Lab Req ID',
  props<{ labReqId: string }>()
);

export const clearActiveLabReqId = createAction('[LabReq] Clear Active Lab Req ID');

export const loadLabReqPdfUrl = createAction(
  '[LabReq] Load Lab Req PDF URL',
  props<{ labReqId: string }>()
);

export const loadLabReqPdfUrlSuccess = createAction(
  '[LabReq] Load Lab Req PDF URL Success',
  props<{ signedUrl: string }>()
);

export const loadLabReqPdfUrlFailure = createAction(
  '[LabReq] Load Lab Req PDF URL Failure',
  props<{ error: any }>()
);
